import { convertTwoDecimalStringToBig } from '../../../utils/bigJSHelper'
import { amountFromInput } from '../../../utils/amountFromInput'

export const validateAmount = (amount: string): boolean => {
  // Verify amount is non-empty
  if (!amount.trim()) {
    return false
  }
  const amountValue = amountFromInput(amount)

  let bigAmountValue
  // Ensure the conversion to number is valid
  try {
    bigAmountValue = convertTwoDecimalStringToBig(amountValue)
  } catch (error) {
    return false
  }

  // Ensure amount is non-zero
  if (bigAmountValue.eq(0)) {
    return false
  }

  // For now we only care that something is non-zero
  return true
}
